import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const IMMUNIZATIONS_QUERY_KEY = "IMMUNIZATIONS_QUERY_KEY";

export const useImmunizationsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [IMMUNIZATIONS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getAllImmunizations.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useImmunizationQuery = (id, patientUserId) => {
  return useQuery({
    queryKey: [IMMUNIZATIONS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getAllImmunizations.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
    select: (immunizations) => {
      const immunization = immunizations.filter((i) => i.id === id)[0];
      if (immunization) {
        return {
          ...immunization,
          administeredDate:
            immunization.administeredDate?.replace(/-/g, "/") ?? "",
          expirationDate: immunization.expirationDate?.replace(/-/g, "/") ?? "",
          detailsTags: JSON.parse(immunization.detailsTags ?? '[]'),
        };
      }
      return null;
    },
  });
};

const getAllImmunizations = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "pcmedapi",
    path: "/immunizations/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
